module.exports = new __parcel__URL__("layers-2x.b7b89169.png").toString();